module.exports = __webpack_public_path__ + "img/8.8.TSS.1d29e17e.png";